module.exports = __webpack_public_path__ + "2acb60f2/img/mini-logo.18817ee5.svg";